let LockbodyScrolling = 0;
const className = 'lockbody';

export default function Lockbody() {
    let body = document.body;
    let hasClass = body.classList.contains(className);
    let scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (!hasClass) {
        LockbodyScrolling = scrollTop;
    }

    body.classList.toggle(className);
    hasClass = !hasClass;

    if (hasClass) {
        body.style.top = `${LockbodyScrolling * -1}px`;
    } else {
        body.style.top = '';
        window.scrollTo(0, LockbodyScrolling);
        LockbodyScrolling = 0;
    }

    return hasClass;
}
